import { FlexibleBaseSpecification, FlexibleModelBase } from './flexible_base';

export interface FlexibleListedAtReceptionsSpecification extends FlexibleBaseSpecification {
	title: string;
}

export class FlexibleListedAtReceptionsModel extends FlexibleModelBase {
	public readonly title: string;

	constructor(spec: FlexibleListedAtReceptionsSpecification) {
		super(spec);

		this.title = spec.title;
	}
}
